import React from "react";
import { connect } from "react-redux";
import SubNavigation from "./SubNavigation";
import { Link, withRouter } from "react-router-dom";
import { NavLink } from 'react-router-dom';
import { selectIsPLGAccount } from "../../../store/userSelectors";

class ReviewNavigation extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      toggleMenu: false,
      active: false,
    };

  }

  toggleNavMenu = (event, tab) => {
    this.setState({
      active: tab,
      toggleMenu: !this.state.toggleMenu
    })
    // if(tab!="settings"){
    //   this.setState({
    //     settingActive:0,
    //    })
    // }
  };
  redirectUser = (link) => {
    this.setState({
      active: "settings",
      toggleMenu: true
    });


    if (link === "team-listing") {
      this.setState({ activeLink: "team-listing" });
      this.props.history.push("/settings/team-listing");
    }
    if (link === "connect-review-sites") {
      this.setState({ activeLink: "connect-review-sites" });
      this.props.history.push("/settings/connect-review-sites");
    }
    if (link === "review-sites-settings") {
      this.setState({ activeLink: "review-sites-settings" });
      this.props.history.push("/settings/review-sites-settings");
    }
  };

  render() {
    const { location, isPLG } = this.props;

    // Hide review management for PLG accounts
    if (isPLG) {
      return null;
    }

    let str = location.pathname;
    let arr = str.split('/');
    let settingurl = arr[2];
    console.log(arr);
    return (
      <div className="kt-header__bottom">
        <div className="kt-container" style={{ backgroundColor: "#fff" }}>
          <div
            className="kt-header-menu-wrapper kt-grid__item kt-grid__item--fluid"
            id="kt_header_menu_wrapper"
          >
            <div
              id="kt_header_menu"
              className="kt-header-menu kt-header-menu-mobile "
            >
              <div className="yr-mobpagetitle">Conversations :</div>
              <ul className="kt-menu__nav " style={{ padding: 22 }}>
                <li style={{ display: this.props.user.totalAvailableModules.includes("your_review") ? "" : "none" }} className={`kt-menu__item ${location.pathname == '/your-reviews' ? "kt-menu__item--active linear-gradient-a" : ""} `}>

                  {location.pathname == '/your-reviews' ?
                    <a
                      href="#"

                      className="kt-menu__link kt-menu__toggle "
                    >
                      <span className="kt-menu__link-text">
                        <i class="fa fa-star" aria-hidden="true"></i>
                        Your Reviews
                      </span>

                    </a>
                    :
                    <Link to="/your-reviews" className="kt-menu__link " onClick={(event) => this.toggleNavMenu(event, 'youreview')}>
                      <span className="kt-menu__link-text">
                       <i class="fa fa-star" aria-hidden="true"></i>
                        Your Reviews
                      </span>
                    </Link>}
                </li>
                <li style={{ display: this.props.user.totalAvailableModules.includes("team_activity") ? "" : "none" }} className={`kt-menu__item ${location.pathname == '/team-activity' ? "kt-menu__item--active linear-gradient-a" : ""}  kt-menu__item--submenu kt-menu__item--rel`} aria-haspopup="true" data-ktmenu-submenu-toggle="click">
                  {location.pathname == '/team-activity' ?
                    <a
                      href="#"
                      onClick={(event) => this.toggleNavMenu(event, 'youreview')}
                      className="kt-menu__link kt-menu__toggle "
                    >
                      <span className="kt-menu__link-text">
                         <i className="fa fa-id-card-o" aria-hidden="true"></i>
                        Team Activity
                      </span>
                    </a>
                    :
                    <Link to="/team-activity" className="kt-menu__link " onClick={(event) => this.toggleNavMenu(event, 'youreview')}>
                      <span className="kt-menu__link-text">
                         <i className="fa fa-id-card-o" aria-hidden="true"></i>
                        Team Activity
                      </span>
                    </Link>}

                </li>
                <li style={{ display: this.props.user.totalAvailableModules.includes("request_review") ? "" : "none" }} className={`kt-menu__item ${location.pathname == '/request-a-review-new' ? "kt-menu__item--active linear-gradient-a" : ""}  kt-menu__item--submenu kt-menu__item--rel`} aria-haspopup="true" data-ktmenu-submenu-toggle="click">

                  {location.pathname == '/request-a-review-new' ?
                    <a
                      href="#"
                      onClick={(event) => this.toggleNavMenu(event, 'youreview')}
                      className="kt-menu__link kt-menu__toggle "
                    >
                      <span className="kt-menu__link-text">
                        <i className="fa fa-star-o" aria-hidden="true"></i>
                        Request A Review
                      </span>
                    </a>
                    :
                    <Link to="/request-a-review-new" className="kt-menu__link" onClick={(event) => this.toggleNavMenu(event, 'youreview')}>
                      <span className="kt-menu__link-text">
                        <i className="fa fa-star-o" aria-hidden="true"></i>
                        Request A Review
                      </span>
                      <i className="kt-menu__hor-arrow la la-angle-down" />
                    </Link>}

                </li>
                {/* team */}
                <li style={{ display: this.props.user.totalAvailableModules.includes("team_member") ? "" : "none" }} className={`kt-menu__item ${location.pathname == '/settings/team-listing' ? "kt-menu__item--active linear-gradient-a" : ""}  kt-menu__item--submenu kt-menu__item--rel`} aria-haspopup="true" data-ktmenu-submenu-toggle="click">

                  {location.pathname == '/settings/team-listing' ?
                    <a
                      href="#"
                      onClick={(event) => this.toggleNavMenu(event, 'youreview')}
                      className="kt-menu__link kt-menu__toggle "
                    >
                      <span className="kt-menu__link-text">
                        <i className="fa fa-user-o" aria-hidden="true"></i>
                        Team Members
                      </span>
                    </a>
                    :
                    <Link to="/settings/team-listing" className="kt-menu__link" onClick={(event) => this.toggleNavMenu(event, 'youreview')}>
                      <span className="kt-menu__link-text">
                        <i className="fa fa-user-o" aria-hidden="true"></i>
                        Team Members
                      </span>
                      <i className="kt-menu__hor-arrow la la-angle-down" />
                    </Link>}
                </li>
                {/* connect_review */}
                <li style={{ display: this.props.user.totalAvailableModules.includes("connect_review_site") ? "" : "none" }} className={`kt-menu__item ${settingurl == 'manually-customization' || settingurl == 'settings-customization' || settingurl == 'automated-customization' || location.pathname == '/settings/settings-customization' ? "kt-menu__item--active linear-gradient-a" : ""}  kt-menu__item--submenu kt-menu__item--rel`} aria-haspopup="true" data-ktmenu-submenu-toggle="click">

                  {settingurl == 'settings-customization'
                    || settingurl == 'manually-customization'
                    || settingurl == 'automated-customization'

                    ?

                    <a href="/settings/settings-customization" className="kt-menu__link"
                    >
                      <span className="kt-menu__link-text">
                        <i className="fa fa-code" aria-hidden="true"></i>
                        Settings
                      </span>
                    </a>
                    :
                    <Link to="/settings/settings-customization" className="kt-menu__link" onClick={(event) => this.toggleNavMenu(event, 'settings-customization')}>
                      <span className="kt-menu__link-text">
                       <i className="fa fa-code" aria-hidden="true"></i>
                        Settings
                      </span>
                      <i className="kt-menu__hor-arrow la la-angle-down" />
                    </Link>}
                </li>
                {/* <li  className={`kt-menu__item ${this.state.active == 'settings' || this.props.location.pathname=="/settings/team-listing" || this.props.location.pathname=="/settings/connect-review-sites"  ? "kt-menu__item--active" : ""}  kt-menu__item--submenu kt-menu__item--rel`}
                  data-ktmenu-submenu-toggle="click"
                  aria-haspopup="true"
                >
                  {this.state.toggleMenu && this.state.active == 'settings' ?
                    <a
                      href="#"
                      onClick={(event) => this.toggleNavMenu(event, 'settings')}
                      className="kt-menu__link kt-menu__toggle"
                    >
                      <span className="kt-menu__link-text">
                        <i className="yr-faicon yr-navicon-gareicon" />
                        Settings
                    </span>
                      <i className="kt-menu__hor-arrow la la-angle-down" />
                    </a>
                    :                                      
                    <a  className="kt-menu__link " onClick={(link) => this.redirectUser("team-listing")}>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              
                      <span className="kt-menu__link-text">
                        <i className="yr-faicon yr-navicon-gareicon" />
                        Settings
                    </span>
                      <i className="kt-menu__hor-arrow la la-angle-down" />

                    </a>
                  }
      <div
        style={{ display: this.state.toggleMenu && this.state.active == 'settings' ? "block" : "none" }}  
        className="kt-menu__submenu kt-menu__submenu--classic kt-menu__submenu--left"
      >
        <ul className="kt-menu__subnav">
          <li
            className={`kt-menu__item  ${
              location.pathname === "/settings/team-listing"
                ? " kt-menu__item--active"
                : ""
            }`}
            aria-haspopup="true"
          >
            {" "}
            <a className="kt-menu__link "
            onClick={(link) => this.redirectUser("team-listing")}
            >
              <i className="kt-menu__hor-arrow la la-angle-right" />
              <span />
              <span className="kt-menu__link-text">Team Members</span>
            </a>
          </li>
          <li
            className={`kt-menu__item  ${
              location.pathname === "/settings/connect-review-sites"
                ? " kt-menu__item--active"
                : ""
            }`}
            aria-haspopup="true"
          >
            {" "}
            <a 
              className="kt-menu__link "
              onClick={(link) => this.redirectUser("connect-review-sites")}
            >
              <i className="kt-menu__hor-arrow la la-angle-right" />
              <span />
              <span className="kt-menu__link-text">Connect Review Sites</span>
            </a>
          </li>
        </ul>
      </div>
                </li> */}

              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  isPLG: selectIsPLGAccount(state),
});

export default connect(mapStateToProps)(withRouter(ReviewNavigation));

